"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IcomoonReact_1 = require("./IcomoonReact/IcomoonReact");

var IcomoonReact_2 = require("./IcomoonReact/IcomoonReact");

exports.iconList = IcomoonReact_2.iconList;
exports.default = IcomoonReact_1.IcomoonReact;